import * as React from 'react';

import {colors} from 'shells/colors/colors';
import {ImageModal} from 'shells/modal/image-modal';

import {OpenableModals, useOpenableModal} from '../../openable-modals';
import {HelpGraphicUserAssignment} from '../../sales-automation/onboarding/help-user-assignment/help-graphic-user-assignment';

import {InviteUsers} from '../invite-users/invite-users';

export function InviteUsersModal() {
    const {isOpen, onClose} = useOpenableModal(OpenableModals.INVITE_USERS_MODAL);

    return (
        <ImageModal
            isOpen={isOpen}
            onClose={onClose}
            sidebar={{
                image: <HelpGraphicUserAssignment />,
                backgroundColor: colors.plumDk,
            }}
        >
            <InviteUsers />
        </ImageModal>
    );
}
